import { Box, Stack, styled, Typography } from '@mui/material';
import { JobApplicationPeriod, JobApplicationShift } from 'features/myJobs/types';
import { mapSendingStatusToJobStatus } from 'features/myJobs/utils/statusMapper';
import { WithFormattedDate } from 'pages/candidateOffer/types';
import ProcessedOfferStatus from 'pages/candidateOfferList/components/OfferDescription/ProcessedOfferStatus';
import { useTranslation } from 'react-i18next';

interface JobDetailScheduleListItemProps {
    scheduleItem: WithFormattedDate<JobApplicationShift | JobApplicationPeriod>;
}

export default function JobDetailScheduleListItem({ scheduleItem }: JobDetailScheduleListItemProps) {
    return (
        <Root>
            <Stack>
                <Typography fontWeight="medium">
                    { scheduleItem.dateStr } { scheduleItem.startTzStr && scheduleItem.finishTzStr ? ` ${ scheduleItem.startTzStr } - ${ scheduleItem.finishTzStr }` : '' }
                </Typography>
                <Subtitle scheduleItem={ scheduleItem } />
            </Stack>

            <Box>
                <ProcessedOfferStatus status={ mapSendingStatusToJobStatus(scheduleItem.statusForCandidate) } />
            </Box>
        </Root>
    );
}

function Subtitle({ scheduleItem }: JobDetailScheduleListItemProps) {
    const { t } = useTranslation('myJobs');

    if (!scheduleItem.acceptedTzStr) {
        return null;
    }

    return (
        <Typography variant="caption"
            color="text.secondary"
        >
            { t('details.youAcceptedAt', { date: scheduleItem.acceptedTzStr }) }
        </Typography>
    );
}

const Root = styled(Stack)({
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
});
